
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg","data-token-name":"text-align-right"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M.375 2.5c0-.345.28-.625.625-.625h18a.625.625 0 110 1.25H1A.625.625 0 01.375 2.5zm5.947 3.751c0-.345.28-.625.625-.625h12.054a.625.625 0 110 1.25H6.947a.625.625 0 01-.625-.625zM4.313 10c0-.346.28-.626.625-.626H19a.625.625 0 110 1.25H4.937A.625.625 0 014.313 10zm4.378 3.75c0-.345.28-.625.625-.625H19a.625.625 0 110 1.25H9.316a.625.625 0 01-.625-.625zM3.51 17.5c0-.345.28-.625.625-.625H19a.625.625 0 110 1.25H4.135a.625.625 0 01-.625-.625z","fill":"currentColor"}})])
          )
        }
      }
    